import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("fiorucci_cookie_consent")) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem("fiorucci_cookie_consent", choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-petrol text-[#FDFBF7] px-6 md:px-12 py-5"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
        <p className="text-sm text-white/85 max-w-2xl">
          {t("cookie.text")}{" "}
          <Link to="/cookie-policy" className="text-gold link-underline">
            {t("cookie.more")}
          </Link>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-decline"
            onClick={() => decide("declined")}
            className="text-sm px-5 py-2 border border-white/30 rounded-sm hover:bg-white/10 transition-colors"
          >
            {t("cookie.decline")}
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="text-sm px-5 py-2 bg-gold text-petrol rounded-sm hover:bg-[#c4a030] transition-colors font-medium"
          >
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
